(function () {
  var root = document.querySelector('[data-tp]');
  if (!root || root.__tp) return;
  root.__tp = true;
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  var mq = window.matchMedia('(max-width:640px)');

  /* ---------- gallery ---------- */
  var slides = $$('.tp-slide'), thumbs = $$('.tp-thumbs button'), track = $('.tp-slides'), count = $('.tp-count'), dotsEl = $('.tp-dots');
  var cur = 0, dots = [];
  if (dotsEl && slides.length > 1 && slides.length <= 15) {
    slides.forEach(function (_, i) { var d = document.createElement('span'); if (!i) d.className = 'is-on'; dotsEl.appendChild(d); dots.push(d); });
  }
  function mark(i) {
    cur = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
  }
  function show(i, scroll) {
    if (i < 0 || i >= slides.length) return;
    mark(i);
    if (scroll && mq.matches && track) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  thumbs.forEach(function (t, k) {
    t.addEventListener('mouseenter', function () { show(k); });
    t.addEventListener('click', function () { show(k); });
  });
  if (track) track.addEventListener('scroll', function () {
    if (!mq.matches) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (i !== cur && i < slides.length) mark(i);
  }, { passive: true });
  slides.forEach(function (s, k) {
    var img = s.querySelector('img');
    if (!img || !s.dataset.full) return;
    s.addEventListener('mousemove', function (e) {
      if (mq.matches || window.matchMedia('(hover:none)').matches) return;
      var r = s.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      s.classList.add('is-zoom');
    });
    s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
    s.addEventListener('click', function () { openLb(k); });
  });

  /* lightbox */
  var lb, lbImg, lbC, lbi = 0, full = slides.map(function (s) { return s.dataset.full || null; });
  function lbSet() { lbImg.src = full[lbi]; lbC.textContent = (lbi + 1) + ' / ' + slides.length; }
  function lbGo(d) {
    var n = lbi;
    for (var t = 0; t < slides.length; t++) { n = (n + d + slides.length) % slides.length; if (full[n]) break; }
    lbi = n; lbSet();
  }
  function lbClose() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  function openLb(i) {
    if (!full[i]) return;
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'tp-lb';
      lb.setAttribute('role', 'dialog');
      lb.innerHTML = '<button type="button" class="tp-lb__x" aria-label="Close">&times;</button><button type="button" class="tp-lb__p" aria-label="Previous">&lsaquo;</button><img alt=""><button type="button" class="tp-lb__n" aria-label="Next">&rsaquo;</button><div class="tp-lb__c"></div>';
      document.body.appendChild(lb);
      lbImg = lb.querySelector('img'); lbC = lb.querySelector('.tp-lb__c');
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('tp-lb__x')) lbClose(); });
      lb.querySelector('.tp-lb__p').addEventListener('click', function () { lbGo(-1); });
      lb.querySelector('.tp-lb__n').addEventListener('click', function () { lbGo(1); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowLeft') lbGo(-1);
        if (e.key === 'ArrowRight') lbGo(1);
      });
    }
    lbi = i; lbSet();
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  /* ---------- variants ---------- */
  var variants = [];
  try { variants = JSON.parse(($('#tp-variants') || {}).textContent || '[]'); } catch (e) {}
  var opts = $$('[data-opt]');
  function sel() { return opts.map(function (o) { var b = o.querySelector('.tp-sw.is-on'); return b ? b.dataset.val : null; }); }
  function setAll(s, fn) { $$(s).forEach(fn); }
  function apply(v) {
    var ok = !!(v && v.available);
    setAll('[data-vid]', function (i) { i.value = v ? v.id : ''; });
    if (v) {
      setAll('[data-price]', function (e) { e.textContent = v.price; });
      setAll('[data-mrp]', function (e) { e.textContent = v.mrp; });
      setAll('[data-mrpw]', function (e) { e.hidden = !v.pct; });
      setAll('[data-pct]', function (e) { e.hidden = !v.pct; e.textContent = '-' + v.pct + '%'; });
      setAll('[data-pctt]', function (e) { e.textContent = '(' + v.pct + '% off)'; });
      setAll('[data-deal]', function (e) { e.hidden = v.pct < 10; });
      setAll('[data-sku]', function (e) { e.textContent = v.sku || ''; });
      setAll('[data-skurow]', function (e) { e.hidden = !v.sku; });
      if (v.media) { var k = slides.findIndex(function (s) { return s.dataset.mediaId == v.media; }); if (k >= 0) show(k, true); }
      try { history.replaceState(history.state, '', location.pathname + '?variant=' + v.id); } catch (e) {}
    }
    setAll('[data-stock]', function (e) { e.textContent = !v ? 'Not available in this combination' : (ok ? 'In stock' : 'Currently unavailable'); e.classList.toggle('is-out', !ok); });
    setAll('[data-stock2]', function (e) { e.textContent = ok ? 'In stock' : 'Unavailable'; });
    setAll('[data-atc],[data-buynow],[data-bar-atc]', function (b) { b.disabled = !ok; });
  }
  function avail(s) {
    opts.forEach(function (o, oi) {
      $$('.tp-sw', o).forEach(function (b) {
        var test = s.slice(); test[oi] = b.dataset.val;
        var has = variants.some(function (v) { return v.available && v.options.every(function (x, i) { return x === test[i]; }); });
        b.classList.toggle('is-na', !has);
      });
    });
  }
  opts.forEach(function (o, oi) {
    o.addEventListener('click', function (e) {
      var b = e.target.closest('.tp-sw'); if (!b) return;
      $$('.tp-sw', o).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      $('[data-opt-val]', o).textContent = b.dataset.val;
      setAll('[data-fact="' + oi + '"]', function (e2) { e2.textContent = b.dataset.val; });
      var s = sel();
      var v = variants.find(function (x) { return x.options.every(function (val, i) { return val === s[i]; }); });
      apply(v); avail(s);
    });
  });
  if (opts.length) avail(sel());

  /* about: see more */
  var more = $('[data-more]');
  if (more) more.addEventListener('click', function () {
    var ul = $('[data-about]'); var open = ul.classList.toggle('is-open');
    more.textContent = open ? 'See less' : 'See more product details';
  });

  /* ---------- cart ---------- */
  var form = document.getElementById('tp-form');
  var toast;
  function showToast(ok, msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'tp-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.classList.toggle('is-err', !ok);
    toast.innerHTML = '';
    var p = document.createElement('p'); p.textContent = ok ? '✓ Added to Cart' : 'Could not add to cart';
    toast.appendChild(p);
    var sm = document.createElement('small'); sm.textContent = ok ? root.dataset.title : (msg || 'Please try again.'); toast.appendChild(sm);
    if (ok) {
      var a1 = document.createElement('a'); a1.href = '/checkout'; a1.textContent = 'Proceed to Buy'; toast.appendChild(a1);
      var a2 = document.createElement('a'); a2.href = '/cart'; a2.textContent = 'Go to Cart'; toast.appendChild(a2);
    }
    toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 7000);
  }
  function addToCart() {
    return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
        var t = el.querySelector('span:not(.visually-hidden)') || el; t.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  function busy(b, on) { if (b) b.classList.toggle('is-busy', on); }
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = $('[data-atc]'); busy(b, true);
      addToCart().then(function () { showToast(true); refreshCount(); })
        .catch(function (err) { showToast(false, err.message); })
        .then(function () { busy(b, false); });
    });
    var bn = $('[data-buynow]');
    if (bn) bn.addEventListener('click', function () {
      busy(bn, true);
      addToCart().then(function () { location.href = '/checkout'; })
        .catch(function (err) { busy(bn, false); showToast(false, err.message); });
    });
    var ba = $('[data-bar-atc]');
    if (ba) ba.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
  }
  var bar = $('[data-bar]'), buy = $('[data-buybox]');
  if (bar && buy) {
    var ticking = false;
    function chk() { ticking = false; bar.classList.toggle('is-on', buy.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(chk); } }, { passive: true });
    window.addEventListener('resize', chk); chk();
  }

  /* ---------- rows ---------- */
  var seen = {}; seen[root.dataset.url] = 1;
  function key(href) { try { return new URL(href, location.href).pathname; } catch (e) { return href; } }
  function arrows(row) {
    var tr = $('.tp-track', row), sc = $('.tp-scroll', row);
    if (!tr || sc.querySelector('.tp-arw')) return;
    var p = document.createElement('button'), n = document.createElement('button');
    p.type = n.type = 'button'; p.className = 'tp-arw tp-arw--p'; n.className = 'tp-arw tp-arw--n';
    p.setAttribute('aria-label', 'Previous'); n.setAttribute('aria-label', 'Next');
    p.innerHTML = '&lsaquo;'; n.innerHTML = '&rsaquo;';
    sc.appendChild(p); sc.appendChild(n);
    function upd() { p.hidden = tr.scrollLeft < 5; n.hidden = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 5; }
    p.addEventListener('click', function () { tr.scrollBy({ left: -tr.clientWidth * 0.9 }); });
    n.addEventListener('click', function () { tr.scrollBy({ left: tr.clientWidth * 0.9 }); });
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }
  function fill(row, url) {
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html');
      var cards = Array.prototype.slice.call(d.querySelectorAll('.tp-track .tp-card'));
      var tr = $('.tp-track', row); var n = 0;
      cards.forEach(function (c) { var k = key(c.getAttribute('href')); if (seen[k]) return; seen[k] = 1; tr.appendChild(document.importNode(c, true)); n++; });
      if (n >= 3) { row.hidden = false; arrows(row); } else row.remove();
    }).catch(function () { row.remove(); });
  }
  var KW = ['tv unit', 'shoe rack', 'coffee table', 'dining table', 'dining set', 'side table', 'study table', 'office chair', 'bar cabinet', 'chest of drawers', 'book shelf', 'bookshelf', 'wall shelf', 'sofa cum bed', 'sofa', 'recliner', 'bed', 'wardrobe', 'mattress', 'chair', 'table', 'cabinet', 'dresser', 'ottoman', 'bench', 'stool', 'desk', 'sideboard', 'console', 'swing', 'diwan', 'divan', 'pouf', 'cushion', 'curtain', 'lamp', 'chandelier', 'pendant', 'light', 'basin', 'faucet', 'tap', 'sink', 'shower', 'plywood', 'laminate', 'veneer', 'tile', 'door', 'handle', 'hinge', 'lock', 'wallpaper', 'mirror', 'rug', 'carpet', 'vase', 'clock', 'planter', 'rack', 'shelf', 'storage', 'crockery', 'dinner set', 'cookware', 'drill', 'tool'];
  function keyword() {
    if (root.dataset.kw) return root.dataset.kw;
    var t = (root.dataset.title || '').toLowerCase();
    for (var i = 0; i < KW.length; i++) { var re = new RegExp('\\b' + KW[i] + 's?\\b'); if (re.test(t)) return KW[i]; }
    return '';
  }
  var recs = $('[data-row="recs"]'), srch = $('[data-row="search"]'), col = $('[data-row="col"]');
  var chain = recs ? fill(recs, recs.dataset.src) : Promise.resolve();
  chain.then(function () {
    var kw = keyword();
    if (!srch) return;
    if (!kw) { srch.remove(); return; }
    var tt = $('[data-row-title]', srch); tt.textContent = 'More ' + kw.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) + ' options';
    return fill(srch, '/search?q=' + encodeURIComponent(kw) + '&type=product&options%5Bprefix%5D=last&section_id=tl-pdp-row');
  }).then(function () {
    if (!col) return;
    var left = 0;
    $$('.tp-card', col).forEach(function (c) { var k = key(c.getAttribute('href')); if (seen[k]) c.remove(); else { seen[k] = 1; left++; } });
    if (left < 3) col.remove(); else arrows(col);
  });

  /* siblings (other colours / sizes of the same model) */
  var base = root.dataset.base, sibs = $('[data-tp-sibs]');
  if (base && sibs) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(base) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); }).then(function (j) {
        var list = ((j.resources || {}).results || {}).products || [];
        var pre = base.toLowerCase() + ' (';
        var others = list.filter(function (x) { return x.title.toLowerCase().indexOf(pre) === 0 && key(x.url) !== root.dataset.url; });
        if (!others.length) return;
        var box = $('.tp-sibs__list', sibs);
        function add(t, url, img, on) {
          var a = document.createElement('a'); a.className = 'tp-sib' + (on ? ' is-on' : ''); a.href = url; a.title = t;
          var im = document.createElement('img'); im.loading = 'lazy'; im.alt = ''; im.src = img; a.appendChild(im);
          var s = document.createElement('span'); s.textContent = t.slice(base.length + 2).replace(/\)\s*$/, ''); a.appendChild(s);
          box.appendChild(a);
        }
        add(root.dataset.title, root.dataset.url, root.dataset.img, true);
        others.forEach(function (x) { add(x.title, x.url, x.image || (x.featured_image && x.featured_image.url) || '', false); });
        sibs.hidden = false;
      }).catch(function () {});
  }

  /* recently viewed */
  try {
    var KEY = 'tp_rv', me = { u: root.dataset.url, t: root.dataset.title, i: root.dataset.img, p: root.dataset.price };
    var a = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (x) { return x && x.u && x.u !== me.u; });
    var rv = $('[data-row="rv"]');
    if (rv && a.length >= 2) {
      var tr = $('.tp-track', rv);
      a.slice(0, 16).forEach(function (x) {
        var c = document.createElement('a'); c.className = 'tp-card'; c.href = x.u;
        var im = document.createElement('span'); im.className = 'tp-card__img';
        var img = document.createElement('img'); img.loading = 'lazy'; img.alt = ''; img.src = x.i; im.appendChild(img); c.appendChild(im);
        var t = document.createElement('span'); t.className = 'tp-card__t'; t.textContent = x.t; c.appendChild(t);
        if (x.p && /[1-9]/.test(x.p)) { var pp = document.createElement('span'); pp.className = 'tp-card__p'; var b = document.createElement('b'); b.textContent = x.p; pp.appendChild(b); c.appendChild(pp); }
        tr.appendChild(c);
      });
      rv.hidden = false; arrows(rv);
    }
    a.unshift(me);
    localStorage.setItem(KEY, JSON.stringify(a.slice(0, 24)));
  } catch (e) {}
})();
